import styled from 'styled-components';
import { SubmitButtonState } from '.';

interface BaseProps {
	state: SubmitButtonState;
	colors?: {
		disabled?: string;
		hover?: string;
		active?: string;
	};
}

export const Base = styled.div<BaseProps>`
	// i want to shift the icon down by 2px while matching height and width
	// so i reduce height by 2px to 24px
	width: 22px;
	height: 20px;
	padding-top: 2px;

	display: flex;
	align-items: center;
	justify-content: center;
	background: ${({ state, theme, colors }) => {
		if (state === SubmitButtonState.DISABLED) {
			return colors?.disabled || theme.gray[400];
		}
		return colors?.active || theme.gray[1000];
	}};
	&:hover {
		background: ${({ state, theme, colors }) => {
			if (state === SubmitButtonState.DISABLED) {
				return colors?.disabled || theme.gray[400];
			}
			return colors?.hover || theme.gray[700];
		}};
	}
	border-radius: 40px;
`;

export const Icon = styled.div`
	// filter out mouse events on the icon, so that all clicks go to the base
	// otherwise Icon will block clicks on Base, and we won't detect when the user clicks the button
	pointer-events: none;
`;
